import React from 'react';
import { Layout, Affix, Icon } from 'antd';
import { withRouter } from 'react-router-dom';
import { css } from '@emotion/css';
import { DataSearch } from '@appbaseio/reactivesearch';
import Suggestions from './Suggestions';

const logoStyles = css`
	box-shadow: 2px 2px #1890ff, 4px 4px #096dd9;
	padding: 10px;
	color: #eaeaea;
	font-weight: 600;
	background: white;
	color: #1890ff;
	border-radius: 2px;
	border: 1px solid #bae7ff;
`;

const headerStyles = css`
	background: #174ff4 !important;
	box-shadow: 0 2px 5px -2px #bfbfbf;
	display: flex;
	justify-content: space-between;
	padding: 0 10px !important;
`;

const searchStyles = css`
	width: 50%;
	@media (max-width: 576px) {
		width: 70%;
	}
	input {
		border: 1px solid #e8e8e8;
		background: white;
		border-radius: 2px;
	}

	input:hover {
		border-color: #d9d9d9;
	}
`;

const { Header } = Layout;

const Navbar = ({ dataSearchProps, searchId }) => (
	<Affix offset={0}>
		<Header className={headerStyles}>
			<a href="/">
				<span className={logoStyles}>BS</span>
			</a>

			<DataSearch
				componentId={searchId}
				dataField={[
					'authors',
					'original_title',
					'original_title.autosuggest',
					'original_title.raw',
					'original_title.search',
					'authors.autosuggest',
					'authors.raw',
					'authors.search',
				]}
				className={searchStyles}
				autosuggest
				URLParams
				showIcon
				fieldWeights={[2, 1, 1, 1, 2, 1, 1, 1]}
				render={({
					value,
					loading,
					downshiftProps: { isOpen, getItemProps, highlightedIndex },
					...data
				}) => {
					return (
						isOpen &&
						Boolean(value.length) && (
							<Suggestions
								{...data}
								getItemProps={getItemProps}
								currentValue={value}
								highlightedIndex={highlightedIndex}
								loading={loading}
							/>
						)
					);
				}}
				placeholder="Search for books & author"
				icon={
					<Icon
						style={{ position: 'absolute', color: '#8c8c8c', marginTop: '11px' }}
						type="search"
					/>
				}
				onValueSelected={value => {
					window.location.href = `/search/?Search="${value}"`;
				}}
				fuzziness={2}
				{...dataSearchProps}
			/>
		</Header>
	</Affix>
);

export default withRouter(Navbar);
